import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { buscarCorreosPersonasPorDato } from "../../services/alertasGenericasService";

const renderTodos = () => <span style={{ color: "#64748b" }}>Todos</span>;
const renderTodas = () => <span style={{ color: "#64748b" }}>Todas</span>;

const FiltrosTendencias = ({
  filtroAnio,
  filtroSemestre,
  filtroPrueba,
  filtroCompetencia,
  correo,
  onCorreoCommitted,
  opcionesAnio,
  opcionesSemestre,
  opcionesCorreo,
  opcionesPrueba,
  opcionesCompetencia = [],
  filtrosDesactivados = false,
  onAnioChange,
  onSemestreChange,
  onPruebaChange,
  onCompetenciaChange,
}) => {
  const [inputCorreo, setInputCorreo] = useState(correo || "");
  const [sugerenciasCorreo, setSugerenciasCorreo] = useState([]);

  useEffect(() => {
    setInputCorreo(correo || "");
  }, [correo]);

  useEffect(() => {
    const t = setTimeout(() => {
      const v = (inputCorreo || "").trim();
      if (v.includes("@")) {
        onCorreoCommitted(v);
      } else if (!v) {
        onCorreoCommitted("");
      }
    }, 450);
    return () => clearTimeout(t);
  }, [inputCorreo, onCorreoCommitted]);

  useEffect(() => {
    const q = (inputCorreo || "").trim();
    if (q.length < 4) {
      setSugerenciasCorreo([]);
      return undefined;
    }
    let activo = true;
    const t = setTimeout(() => {
      buscarCorreosPersonasPorDato(q).then((lista) => {
        if (!activo) return;
        setSugerenciasCorreo(Array.isArray(lista) ? lista : []);
      });
    }, 280);
    return () => {
      activo = false;
      clearTimeout(t);
    };
  }, [inputCorreo]);

  const opcionesAutocompleteCorreo = useMemo(() => {
    const padre = Array.isArray(opcionesCorreo) ? opcionesCorreo : [];
    const map = new Map();
    [...sugerenciasCorreo, ...padre].forEach((c) => {
      const x = (c || "").trim();
      if (x) map.set(x.toLowerCase(), x);
    });
    const q = (inputCorreo || "").trim().toLowerCase();
    let list = [...map.values()];
    if (q) {
      list = list.filter((c) => c.toLowerCase().includes(q));
    }
    return list.slice(0, 30);
  }, [sugerenciasCorreo, opcionesCorreo, inputCorreo]);

  const gapFiltro = { marginRight: 14, marginBottom: 6 };

  return (
    <Box display="flex" flexWrap="wrap" alignItems="flex-end" style={{ width: "100%" }}>
      <Box style={gapFiltro}>
        <Autocomplete
          freeSolo
          options={opcionesAutocompleteCorreo}
          getOptionLabel={(option) => (typeof option === "string" ? option : "")}
          inputValue={inputCorreo}
          onInputChange={(_, v) => setInputCorreo(v || "")}
          onChange={(_, v) => {
            const next = typeof v === "string" ? v : v || "";
            setInputCorreo(next);
            onCorreoCommitted((next || "").trim());
          }}
          filterOptions={(opts, state) => {
            const q = (state.inputValue || "").trim().toLowerCase();
            if (!q) return opts;
            return opts.filter((c) => c.toLowerCase().includes(q));
          }}
          style={{ minWidth: 240, maxWidth: 320 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Correo electrónico"
              variant="outlined"
              size="small"
              placeholder="usuario@cuc.edu.co"
              style={{ background: "#fff" }}
              InputProps={{ ...params.InputProps, style: { fontSize: 12 } }}
              InputLabelProps={{ shrink: true, style: { fontSize: 12 } }}
            />
          )}
        />
      </Box>

      <Box style={gapFiltro}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 108 }} disabled={filtrosDesactivados}>
          <InputLabel shrink style={{ fontSize: 12, fontWeight: 600 }}>
            Año
          </InputLabel>
          <Select
            displayEmpty
            value={filtroAnio}
            onChange={(e) => onAnioChange(e.target.value)}
            label="Año"
            style={{ height: 36, fontSize: 12 }}
            renderValue={(v) => (v === "" || v == null ? renderTodos() : v)}
          >
            <MenuItem value="">
              <em>Todos</em>
            </MenuItem>
            {opcionesAnio.map((anio) => (
              <MenuItem key={anio} value={anio} style={{ fontSize: 12 }}>
                {anio}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box style={gapFiltro}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 124 }} disabled={filtrosDesactivados || !filtroAnio}>
          <InputLabel shrink style={{ fontSize: 12, fontWeight: 600 }}>
            Semestre
          </InputLabel>
          <Select
            displayEmpty
            value={filtroSemestre}
            onChange={(e) => onSemestreChange(e.target.value)}
            label="Semestre"
            style={{ height: 36, fontSize: 12 }}
            renderValue={(v) => (v === "" || v == null ? renderTodos() : v)}
          >
            <MenuItem value="">
              <em>Todos</em>
            </MenuItem>
            {opcionesSemestre.map((s) => (
              <MenuItem key={s} value={s} style={{ fontSize: 12 }}>
                {s}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box style={gapFiltro}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 138 }} disabled={filtrosDesactivados}>
          <InputLabel shrink style={{ fontSize: 12, fontWeight: 600 }}>
            Competencia
          </InputLabel>
          <Select
            displayEmpty
            value={filtroCompetencia || "RC"}
            onChange={(e) => onCompetenciaChange(e.target.value)}
            label="Competencia"
            style={{ height: 36, fontSize: 12 }}
            renderValue={(v) => (v === "" || v == null ? renderTodas() : (opcionesCompetencia.find((item) => item.codigo === v)?.nombre || v))}
          >
            {opcionesCompetencia.map((item) => (
              <MenuItem key={item.codigo} value={item.codigo} style={{ fontSize: 12 }}>
                {item.nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box style={gapFiltro}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 132 }} disabled={filtrosDesactivados}>
          <InputLabel shrink style={{ fontSize: 12, fontWeight: 600 }}>
            Prueba
          </InputLabel>
          <Select
            displayEmpty
            value={filtroPrueba}
            onChange={(e) => onPruebaChange(e.target.value)}
            label="Prueba"
            style={{ height: 36, fontSize: 12 }}
            renderValue={(v) => (v === "" || v == null ? renderTodas() : v)}
          >
            <MenuItem value="">
              <em>Todas</em>
            </MenuItem>
            {opcionesPrueba.map((p) => (
              <MenuItem key={p} value={p} style={{ fontSize: 12 }}>
                {p}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default FiltrosTendencias;
